import React from "react";
import { FieldValues } from "react-hook-form";
import { HiddenInput } from "./HiddenInput";
import { HookFormHiddenInputProps } from "./HiddenInput.types";

export const HookFormHiddenInput = <T extends FieldValues>(
  props: HookFormHiddenInputProps<T>
): React.ReactElement => {
  const { form, name, ...rest } = props;
  return <HiddenInput {...form.register(name)} {...rest} />;
};
